/**
 * How a teammate is named in a picker or a label, so two people with the same
 * display name can be told apart (#799 QA: two Org Admins called "James
 * Saludario" showed up as two identical "Referred by" options, two identical
 * "Correct credit" choices, and an Attribution panel that could not say which).
 *
 * The name alone when it is unique in the list; "Name (email)" when another
 * teammate shares it. Names compare trimmed and case-insensitively.
 */
const key = (name) => String(name || '').trim().toLowerCase();

export function teammateLabels(members) {
    const list = Array.isArray(members) ? members : [];
    const counts = new Map();
    list.forEach((m) => {
        const k = key(m?.name);
        if (k) counts.set(k, (counts.get(k) || 0) + 1);
    });
    const labels = new Map();
    list.forEach((m) => {
        if (!m?.user_id) return;
        const name = String(m.name || '').trim();
        if (!name) labels.set(m.user_id, m.email || 'Unnamed teammate');
        else if (counts.get(key(name)) > 1 && m.email) labels.set(m.user_id, `${name} (${m.email})`);
        else labels.set(m.user_id, name);
    });
    return labels;
}

/** What an owner/coach/author shows as (#864 vocabulary): the name, "Former member" for an id that no
 *  longer resolves to one, and null for "nobody", which each surface renders as its own muted dash. */
export const FORMER_MEMBER = 'Former member';
export const personLabel = (id, name) => name || (id ? FORMER_MEMBER : null);

export default teammateLabels;
